<script setup lang="ts">
import { computed } from "vue";
import { useGepAiVoiceCaller } from "@/composables/useGepAiVoiceCaller";

const props = defineProps<{
  enabled: boolean;
  merchantId?: string;
  language?: string;
  token?: string;
}>();

const isEnabled = computed(() => props.enabled);
const merchantId = computed(() => props.merchantId);
const language = computed(() => props.language);
const token = computed(() => props.token);
const { state } = useGepAiVoiceCaller({
  enabled: isEnabled,
  merchantId,
  language,
  token,
});
</script>

<template>
  <div v-if="enabled" class="gep-ai-voice-call" data-test="gep-ai-voice-call">
    <div id="gep-ai-voice-caller-mount" class="gep-ai-voice-call__mount" />
    <p v-if="state.error" class="gep-ai-voice-call__error" role="status">
      AI voice assistance is unavailable right now.
    </p>
  </div>
</template>

<style scoped>
.gep-ai-voice-call {
  position: fixed;
  right: 20px;
  bottom: max(20px, env(safe-area-inset-bottom));
  z-index: 65;
}
.gep-ai-voice-call__mount :deep(button) {
  min-height: 48px;
  padding: 12px 16px !important;
  border: 0 !important;
  border-radius: 999px !important;
  background: #002037 !important;
  color: #fff !important;
  box-shadow: 0 8px 24px rgb(0 32 55 / 24%) !important;
  font:
    600 14px/1.2 Montserrat,
    Arial,
    sans-serif !important;
}
.gep-ai-voice-call__error {
  max-width: 230px;
  margin: 8px 0 0;
  padding: 8px 10px;
  border-radius: 8px;
  background: #fff;
  color: #002037;
  box-shadow: 0 4px 12px rgb(0 32 55 / 18%);
  font-size: 12px;
}
</style>
